
(function (window, document, jQuery, undefined) {

    // map to local vars
    var $ = jQuery.noConflict();
    var $document = $(document);
    var $body = $('body').first();

    // trigger
    $document.ready(function () {
        // IE can't do this
        if (!$body.hasClass('is-ie')) {
            TransformForms();
        }
    });

    // transform forms
    function TransformForms() {
        var $omnicare = $('.site-omnicare').first();
        if ($omnicare.length) {
            var $forms = $omnicare.find('.don-form');

            // transform form components
            $forms.each(function () {
                var $form = $(this);
                var $container = $form.parent().parent();

                // add transforming class
                $form.addClass('is-transforming');

                // remove trigger from container
                $container.off('DOMSubtreeModified');

                // transform submit button
                var $btnSubmit = $form.find('input[type=submit]').first();
                if ($btnSubmit.length) {
                    $btnSubmit.replaceWith('<button class="btn btn-primary" type="submit">' + $btnSubmit.val() + ' <i class="fas fa-long-arrow-alt-right"></i></button>');
                }
                

                // transform form-fields that contain text inputs
                var $formFields = $form.find('.form-field');
                $formFields.each(function () {
                    var $formField = $(this);
                    var $inputs = $formField.find('input.form-control[type="text"]')
                        .add($formField.find('input.form-control[type="email"]'))
                        .add($formField.find('input.form-control[type="password"]'))
                        .add($formField.find('textarea.form-control'))
                        .add($formField.find('select.form-control'));

                    // transform inputs
                    if ($inputs.length) {
                        // transform component
                        $inputs.addClass('don-form__text-control');

                        // transform form-field
                        $formField.addClass('don-form__text-field');
                        if ($inputs.val()) {
                            $formField.addClass('has-value');
                        }
                        $inputs.on('focus', function () {
                            $formField.addClass('has-focus');
                        });
                        $inputs.on('blur', function () {
                            $formField.removeClass('has-focus');
                        });
                        $inputs.on('change', function () {
                            if ($(this).val()) {
                                $formField.addClass('has-value');
                            }
                            else {
                                $formField.removeClass('has-value');
                            }
                        });
                    }

                    // transform select wrappers
                    $formField.find('select.form-control').parent().addClass('don-form__select-wrapper');
                });

                // apply trigger to form container
                $container.on('DOMSubtreeModified', function () {
                    TransformForms();
                });

                // wait .2s to avoid visible transformations
                window.setTimeout(function () {
                    // remove transforming and add transformed class
                    $form.removeClass('is-transforming');
                    $form.addClass('is-transformed');
                }, 200);
            });
        }
    }
})(window, document, jQuery);
